export const GET_CERTIFICATES = 'ENCRYPT_GET_CERTIFICATES';
export const ENCRYPT = 'ENCRYPT';
